import React from 'react'
import Modal from "../../../common/Modal/Modal";
import { BRAND_NAME } from "../../../../brand";

export default function RegNotifyAdmin(props) {
    return (
        <Modal hasBackButton={true} handleBack={props.handleBack} className="login" >
           { props.selectedCompany &&
                <form onSubmit={(e) => props.onSubmit(e)}>
                    <p className="content2 light-black text-center gap-above-m">To join {BRAND_NAME} as part of</p>
                    <p className="content1 heavy text-center gap-below-xs gap-above-xs">{props.selectedCompany.name}</p>
                    <p className="content2 light-black text-center gap-below-m">You must be admitted by someone from the company.</p>
                    <p className="content2 light-black text-center gap-below-l">First, verify your email address by hitting "send" and clicking the link sent to your email. Once this step is complete, the company will be notified of your request to join, and will be able to admit you.</p>
                    <button id="request_admission" type="submit" className="btn pri expand" disabled={props.isSubmitting} >{props.isSubmitting ? "Sending..." : "Send Link"}</button>
                </form>
            }
        </Modal>
    )
}
